/* 動画（Shopify動画／YouTube／Vimeo）の面倒を見るカスタム要素。
   ■ 自動再生する動画
     ① 再生しはじめる位置 … 画面の上から --video-start% の線を越えたら再生する
     ② 終わったら頭出し   … ループしない動画は、最後まで来たら0秒へ戻して止める
     ③ コントロール       … data-controls が付いていれば、自動再生中でも再生バーを出す
   ■ 自動再生でない動画（initPoster）
     はじめは操作バーを出さず、暗幕と中央の丸ボタンだけ。押してから再生する。 */
(function () {
  /* 発火位置＝画面の上から何%（テーマ設定＞モーション）。
     🔑 位置の判定は毎回自分で測る。ブラウザの「枠を狭めて監視する」機能（rootMargin）に委ねると、
        枠の大きさが後から決まる場所（テーマ編集画面のプレビュー）で設定を無視した動きになる。
        監視機能は「画面に入ったかどうか」の絞り込みだけに使う（出現アニメ reu-inview.js と同じ）。 */
  var DEFAULT_START = 55;
  var watching = new Set(); // 画面に入っていて、線を測り続けているもの
  var instances = 0; // 自動再生する動画がこのページにいくつあるか
  var ticking = false;

  function startPercent() {
    var raw = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--video-start'));
    if (Number.isNaN(raw)) return DEFAULT_START;
    return Math.min(Math.max(raw, 0), 100);
  }

  function linePx() {
    return window.innerHeight * (startPercent() / 100);
  }

  /* 確認線（緑）。出現アニメの赤・背景の青と同じチェック（--inview-debug）で出る */
  var hasLineParam = new URLSearchParams(window.location.search).has('inviewline');

  function drawDebugLine(line) {
    var show =
      hasLineParam || getComputedStyle(document.documentElement).getPropertyValue('--inview-debug').trim() === '1';
    var bar = document.getElementById('VideoDebugLine');
    if (!show) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'VideoDebugLine';
      bar.style.cssText =
        'position:fixed;left:0;width:100%;height:0;border-top:1px dashed green;z-index:9999;pointer-events:none;font:12px/1.4 monospace;color:green;text-align:right;';
      document.body.appendChild(bar);
    }
    bar.style.top = Math.round(line) + 'px';
    bar.textContent = '動画の再生 ' + startPercent() + '%（画面の上から' + Math.round(line) + 'px）';
  }

  function checkAll() {
    ticking = false;
    var line = linePx();
    if (instances) drawDebugLine(line);
    watching.forEach(function (element) {
      element.checkLine(line);
    });
  }

  function requestCheck() {
    if (!instances || ticking) return; // 自動再生する動画が無いページでは何もしない
    ticking = true;
    requestAnimationFrame(checkAll);
  }

  window.addEventListener('scroll', requestCheck, { passive: true });
  window.addEventListener('resize', requestCheck);

  /* ───────── 自動再生でない動画の全画面（スマホ）─────────
     OS標準のプレイヤーへ渡さず、画面いっぱいの層を自分で出す。
     🔑 動画の要素をカードから層へ「移す」＝読み込み直しが起きないので、タップした瞬間に開く。
        新しく作り直すと、そこから読み込みが始まって待ち時間になる。
     コントロールは出さず、タップで再生/一時停止・上下フリックで閉じる。
     見た目の速さと閉じ方は、画像の拡大表示と同じトークン（--swipe-*）に合わせている。 */
  var SP = window.matchMedia('(max-width: 749px)');
  var DRAG_MIN = 8; // これ以上動かして初めてフリック扱い（タップを邪魔しない）
  var stage = null;
  var stageOwner = null;
  var stageUserPaused = false; // 自分で止めたのか、ブラウザが止めたのかを見分ける

  function motion(name, fallback) {
    var raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var value = parseFloat(raw);
    if (Number.isNaN(value)) return fallback;
    return raw.endsWith('ms') ? value : value * 1000;
  }

  function motionNumber(name, fallback) {
    var value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
    return Number.isNaN(value) ? fallback : value;
  }

  function buildStage() {
    var el = document.createElement('div');
    el.className = 'videoStage';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', '動画');
    el.tabIndex = -1;
    el.innerHTML = '<div class="videoStage__bar"><span></span></div>';
    document.body.appendChild(el);

    var startY = 0;
    var startTime = 0;
    var shift = 0;
    var tracking = false;
    var dragging = false;

    function reset() {
      el.classList.remove('isDragging', 'isDismissing', 'isReturning');
      el.style.removeProperty('--dismiss-shift');
      tracking = false;
      dragging = false;
      shift = 0;
    }
    el.resetSwipe = reset;

    el.addEventListener('pointerdown', function (e) {
      reset();
      tracking = true;
      startY = e.clientY;
      startTime = e.timeStamp;
    });

    el.addEventListener('pointermove', function (e) {
      if (!tracking) return;
      var move = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(move) < DRAG_MIN) return;
        dragging = true;
        el.classList.add('isDragging');
        try { el.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
      shift = move;
      el.style.setProperty('--dismiss-shift', shift + 'px');
    });

    function finish(e) {
      if (!tracking) return;
      tracking = false;

      /* 動かしていなければ、ただのタップ＝再生と一時停止の切り替え */
      if (!dragging) {
        togglePlay();
        return;
      }
      dragging = false;

      var elapsed = Math.max(e.timeStamp - startTime, 1);
      var away =
        Math.abs(shift) > window.innerHeight * motionNumber('--swipe-threshold', 0.15) ||
        Math.abs(shift) / elapsed > motionNumber('--swipe-velocity', 0.5);

      el.classList.remove('isDragging');
      if (!away) {
        el.classList.add('isReturning');
        el.style.setProperty('--dismiss-shift', '0px');
        setTimeout(reset, motion('--swipe-back-dur', 250));
        return;
      }
      el.classList.add('isDismissing');
      el.style.setProperty('--dismiss-shift', Math.sign(shift) * window.innerHeight + 'px');
      setTimeout(closeStage, motion('--swipe-out-dur', 300));
    }

    el.addEventListener('pointerup', finish);
    el.addEventListener('pointercancel', function () { reset(); });
    return el;
  }

  function togglePlay() {
    var video = stage && stage.querySelector('video');
    if (!video) return;
    if (video.paused) {
      stageUserPaused = false;
      video.play().catch(function () {});
    } else {
      stageUserPaused = true;
      video.pause();
    }
  }

  function markPaused() {
    var video = stage && stage.querySelector('video');
    if (!stage || !video) return;
    stage.classList.toggle('isPaused', video.paused);
  }

  /* 最後まで来たら頭出しして止める（Task2 の「終了後は最初のフレームに戻す」と同じ扱い） */
  function rewindStage() {
    var video = stage && stage.querySelector('video');
    if (!video) return;
    try { video.currentTime = 0; } catch (error) { /* noop */ }
    markProgress();
    markPaused();
  }

  function markProgress() {
    var video = stage && stage.querySelector('video');
    if (!stage || !video || !video.duration) return;
    stage.style.setProperty('--progress', video.currentTime / video.duration);
  }

  function openStage(element) {
    if (!SP.matches || stageOwner) return;
    if (!stage) stage = buildStage();

    stageOwner = element;
    var video = element.media;
    video.controls = false;
    video.setAttribute('playsinline', '');
    stage.insertBefore(video, stage.firstChild);
    stage.hidden = false;
    stage.classList.remove('isPaused');
    stage.focus();
    document.body.classList.add('overflow-hidden');

    /* 裏で自動再生している動画は止める（音が重なるため） */
    watching.forEach(function (other) { other.pause(); });

    video.addEventListener('play', markPaused);
    video.addEventListener('pause', markPaused);
    video.addEventListener('ended', rewindStage);
    video.addEventListener('timeupdate', markProgress);
    markProgress();
    stageUserPaused = false;
    video.play().catch(function () {});
    markPaused();
    /* 🔑 動画の要素を別の場所へ移すと、仕様上ブラウザが一度止めることがある（Safari）。
       自分で止めたのでなければ、少し置いてもう一度だけ再生を頼む */
    setTimeout(function () {
      if (stageOwner === element && video.paused && !stageUserPaused) video.play().catch(function () {});
    }, 120);
  }

  function closeStage() {
    if (!stage || !stageOwner) return;
    var video = stage.querySelector('video');
    if (video) {
      video.pause();
      video.removeEventListener('play', markPaused);
      video.removeEventListener('pause', markPaused);
      video.removeEventListener('ended', rewindStage);
      video.removeEventListener('timeupdate', markProgress);
      /* カードは表紙の絵に戻す。途中の絵のまま残ると、閉じたあとのカードだけ違う見た目になる */
      try { video.currentTime = 0; } catch (error) { /* 読み込みが済んでいなければ何もしない */ }
      video.controls = false;
      stageOwner.insertBefore(video, stageOwner.firstChild);
      stageOwner.reset();
    }
    stage.hidden = true;
    stage.resetSwipe();
    stage.classList.remove('isPaused');
    document.body.classList.remove('overflow-hidden');
    stageOwner = null;
    /* 閉じたら、裏の自動再生は各自が再開を判断する */
    watching.forEach(function (other) { other.updatePlayback(); });
  }

  document.addEventListener('keyup', function (e) {
    if (stageOwner && e.code === 'Escape') closeStage();
  });

  if (customElements.get('content-media')) return;

  customElements.define(
    'content-media',
    class ContentMedia extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('video, iframe');
        this.autoplay = this.hasAttribute('data-autoplay');
        this.showControls = this.hasAttribute('data-controls');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reduceMotion = this.motionQuery.matches;

        if (!this.media) return;

        /* 自動再生でない動画は、押されるまで再生しない（下の initPoster）。
           自動再生する動画だけが、この先のスクロール連動の仕掛けを使う */
        if (!this.autoplay) {
          this.initPoster();
          return;
        }

        this.loop = this.hasAttribute('data-loop') || (this.media instanceof HTMLVideoElement && this.media.loop);
        instances += 1;
        this.counted = true;
        this.watchEnded();

        if (this.reduceMotion) {
          if (this.media instanceof HTMLVideoElement) this.media.controls = true;
          else this.loadExternalVideo(false);
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          this.onScreen = entries[0].isIntersecting;
          if (this.onScreen) watching.add(this);
          else watching.delete(this);
          this.inView = this.onScreen && this.crossedLine(linePx());
          this.updatePlayback();
        });
        this.observer.observe(this);

        this.scrollItem = this.findScrollItem();
        this.slides = [this.closest('.swiper-slide'), this.closest('.slider__slide'), this.scrollItem].filter(
          (slide, index, slides) => slide && slides.indexOf(slide) === index
        );
        if (this.slides.length) {
          this.slideObserver = new MutationObserver(() => this.updatePlayback());
          this.slides.forEach((slide) => {
            this.slideObserver.observe(slide, {
              attributes: true,
              attributeFilter: ['class', 'aria-hidden', 'data-scroll-current'],
            });
          });
        }

        this.handleVisibilityChange = () => this.updatePlayback();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.handleMotionChange = (event) => {
          this.reduceMotion = event.matches;
          if (this.reduceMotion) {
            this.pause();
            if (this.media instanceof HTMLVideoElement) this.media.controls = true;
            else this.loadExternalVideo(false);
          } else {
            if (this.media instanceof HTMLVideoElement) this.media.controls = this.showControls;
            else this.media.removeAttribute('src');
            this.updatePlayback();
          }
        };
        this.motionQuery.addEventListener('change', this.handleMotionChange);

        if (this.media instanceof HTMLIFrameElement) {
          this.handleMediaLoad = () => {
            if (!this.inView || document.hidden || this.reduceMotion || !this.isActiveSlide()) this.pause();
          };
          this.media.addEventListener('load', this.handleMediaLoad);
        }
      }

      /* 横スクロールする一覧（[data-scroll-fade]）の中にいるなら、自分が乗っているカードを返す。
         現在の1枚には scroll-fade.js が data-scroll-current を付ける */
      findScrollItem() {
        const list = this.closest('[data-scroll-fade]');
        if (!list) return null;
        let node = this;
        while (node.parentElement && node.parentElement !== list) node = node.parentElement;
        return node.parentElement === list ? node : null;
      }

      /* 自動再生でない動画の初期状態＝操作バーを出さず、暗幕と中央の丸ボタンだけを見せる。
         押したら
           ・Shopify動画（PC）＝その場で再生。再生中はマウスを乗せている間だけ操作バーを出す
           ・Shopify動画（スマホ）＝画面いっぱいの層で再生（下の videoStage）
           ・YouTube・Vimeo＝そこで初めて埋め込みを読み込み、各サービスの操作バーに任せる
         ボタンと暗幕は content-media.js が付ける＝JSが動かない環境では
         端末標準の再生バーがそのまま残る（埋め込みは表紙の絵だけになる）。 */
      initPoster() {
        this.classList.add('canPlay');
        this.started = false;

        if (this.media instanceof HTMLVideoElement) {
          this.classList.add('canExpand'); // スマホで画面いっぱいにできるのは Shopify動画だけ
          this.media.controls = false;
          this.watchPlayEnd();
          this.watchHover();
          this.preloadWhenSeen();
        } else {
          this.addPosterImage();
        }

        this.opener = document.createElement('button');
        this.opener.type = 'button';
        this.opener.className = 'videoPlay';
        this.opener.setAttribute('aria-label', '動画を再生');
        this.appendChild(this.opener);
        this.opener.addEventListener('click', () => this.startPlayback());

        /* 画面幅がPCに変わったら、開いている全画面を閉じてカードへ戻す */
        this.handleWidthChange = () => {
          if (!SP.matches && stageOwner === this) closeStage();
        };
        SP.addEventListener('change', this.handleWidthChange);
      }

      startPlayback() {
        if (this.media instanceof HTMLVideoElement) {
          if (SP.matches) {
            openStage(this);
            return;
          }
          this.started = true;
          this.classList.add('isPlaying');
          /* 押した時点でマウスは上にある＝いったん離すまで操作バーが出ないので、ここで出しておく */
          this.media.controls = this.matches(':hover');
          this.media.play().catch(() => {});
          return;
        }

        this.started = true;
        this.classList.add('isPlaying');
        this.playEmbed();
      }

      /* 最後まで再生したら未再生の見た目へ戻す（自動再生の動画と同じ扱い） */
      watchPlayEnd() {
        this.handleDone = () => {
          try {
            this.media.currentTime = 0;
          } catch (error) {
            /* 読み込みが済んでいなければ何もしない */
          }
          this.reset();
        };
        this.media.addEventListener('ended', this.handleDone);
      }

      /* 再生中だけ、マウスを乗せている間（またはキーボードで選んでいる間）操作バーを出す */
      watchHover() {
        this.handleHover = (event) => {
          if (!this.started || SP.matches) return;
          this.media.controls = event.type === 'pointerenter' || event.type === 'focusin';
        };
        ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach((name) =>
          this.addEventListener(name, this.handleHover)
        );
      }

      reset() {
        this.started = false;
        this.classList.remove('isPlaying');
        if (this.media instanceof HTMLVideoElement) this.media.controls = false;
      }

      /* 画面に入ったら先に読み込んでおく＝押した瞬間から動く。
         ページを開いた時点では取りに行かない */
      preloadWhenSeen() {
        this.preloadObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.media.preload = 'auto';
          this.preloadObserver.disconnect();
          this.preloadObserver = null;
        });
        this.preloadObserver.observe(this);
      }

      /* YouTube の表紙の絵。まず大きい絵を頼み、無ければ必ずある小さい絵へ落とす。
         🔑 大きい絵が無い動画でも YouTube は「読み込めなかった」とは言わず、
            120×90 の灰色の絵を返してくる。だから成否ではなく大きさで見分ける。
         Vimeo は表紙の絵のアドレスを作れないため、埋め込みの1コマ目をそのまま表紙に使う */
      addPosterImage() {
        if (this.dataset.provider !== 'youtube') return;
        const videoId = this.dataset.videoId;
        const image = document.createElement('img');
        image.className = 'videoPoster';
        image.alt = '';
        image.loading = 'lazy';
        const useSmallPoster = () => {
          if (image.naturalWidth > 120) return;
          image.removeEventListener('load', useSmallPoster);
          image.removeEventListener('error', useSmallPoster);
          image.src = `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
        };
        image.addEventListener('load', useSmallPoster);
        image.addEventListener('error', useSmallPoster);
        image.src = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
        this.poster = image;
        this.insertBefore(image, this.firstChild);
      }

      /* 押されて初めて埋め込みを読み込む。人が押しているので音つき・操作バーありで始める。
         読み込みが終わるまでは表紙の絵を残す＝真っ黒な間ができない */
      playEmbed() {
        const videoId = this.dataset.videoId;
        const loop = this.hasAttribute('data-loop');

        if (this.poster) {
          this.handlePosterOff = () => {
            this.poster.hidden = true;
          };
          this.media.addEventListener('load', this.handlePosterOff);
        }

        if (this.dataset.provider === 'youtube') {
          const loopParameters = loop ? `&loop=1&playlist=${videoId}` : '';
          this.media.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&playsinline=1&controls=1&autoplay=1${loopParameters}&rel=0&modestbranding=1&origin=${encodeURIComponent(window.location.origin)}`;
          return;
        }
        this.media.src = `https://player.vimeo.com/video/${videoId}?api=1&playsinline=1&controls=1&autoplay=1&loop=${loop ? '1' : '0'}`;
      }

      disconnectedCallback() {
        watching.delete(this);
        if (stageOwner === this) closeStage();
        this.preloadObserver?.disconnect();
        SP.removeEventListener('change', this.handleWidthChange);
        if (this.counted) {
          instances -= 1;
          this.counted = false;
        }
        this.observer?.disconnect();
        this.slideObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.motionQuery?.removeEventListener('change', this.handleMotionChange);
        this.media?.removeEventListener('load', this.handleMediaLoad);
        this.media?.removeEventListener('load', this.handleListen);
        this.media?.removeEventListener('load', this.handlePosterOff);
        this.media?.removeEventListener('ended', this.handleEnded);
        this.media?.removeEventListener('ended', this.handleDone);
        if (this.handleHover) {
          ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach((name) =>
            this.removeEventListener(name, this.handleHover)
          );
        }
        if (this.handleMessage) window.removeEventListener('message', this.handleMessage);
      }

      /* 発火線を越えているか。上端が線より上で、まだ画面から出ていないこと */
      crossedLine(line) {
        const box = this.getBoundingClientRect();
        return box.top <= line && box.bottom > 0;
      }

      checkLine(line) {
        const crossed = this.crossedLine(line);
        if (crossed === this.inView) return;
        this.inView = crossed;
        this.updatePlayback();
      }

      updatePlayback() {
        if (this.inView && !document.hidden && !this.reduceMotion && this.isActiveSlide()) {
          this.play();
          return;
        }
        this.pause();
        /* 横並びの一覧では、再生していないカードも真っ黒にせずサムネイルを出す。
           画面に入ってから読みに行く＝ページを開いた時点では取りに行かない */
        if (
          this.scrollItem &&
          this.onScreen &&
          !this.reduceMotion &&
          this.media instanceof HTMLIFrameElement &&
          !this.media.src
        ) {
          this.loadExternalVideo(false, true);
        }
      }

      isActiveSlide() {
        if (this.scrollItem && !this.scrollItem.hasAttribute('data-scroll-current')) return false;

        const swiperSlide = this.closest('.swiper-slide');
        if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active') && !swiperSlide.classList.contains('is-active')) {
          return false;
        }

        const sliderSlide = this.closest('.slider__slide');
        return !sliderSlide || sliderSlide.getAttribute('aria-hidden') !== 'true';
      }

      /* 最後まで再生したら0秒へ戻して止める（ループ再生のときは何もしない）。
         Shopify動画は ended、YouTube・Vimeo は埋め込み枠とのメッセージのやり取りで終わりを受け取る。
         受け取れない環境では、これまでどおり最後のフレームで止まるだけで他に影響しない */
      watchEnded() {
        if (this.loop) return;

        if (this.media instanceof HTMLVideoElement) {
          this.handleEnded = () => this.rewind();
          this.media.addEventListener('ended', this.handleEnded);
          return;
        }

        this.handleListen = () => this.startListening();
        this.media.addEventListener('load', this.handleListen);

        this.handleMessage = (event) => {
          if (event.source !== this.media.contentWindow) return;
          let data = event.data;
          if (typeof data === 'string') {
            try {
              data = JSON.parse(data);
            } catch (error) {
              return;
            }
          }
          if (!data) return;

          if (this.dataset.provider === 'youtube') {
            /* 状態は onStateChange なら数値、infoDelivery なら info.playerState。0＝終わり */
            const state = data.event === 'onStateChange' ? data.info : data.info && data.info.playerState;
            if (state === 0) this.rewind();
            return;
          }

          if (data.event === 'ready') this.startListening();
          if (data.event === 'ended') this.rewind();
        };
        window.addEventListener('message', this.handleMessage);
      }

      /* 終わりを知らせてもらうよう埋め込み枠へ頼む。読み込み直後と ready の両方で頼んで取りこぼさない */
      startListening() {
        const target = this.media.contentWindow;
        if (!target || !this.media.src) return;
        if (this.dataset.provider === 'youtube') {
          target.postMessage(JSON.stringify({ event: 'listening', channel: 'widget' }), '*');
        } else {
          target.postMessage(JSON.stringify({ method: 'addEventListener', value: 'ended' }), '*');
        }
      }

      rewind() {
        if (this.loop) return;
        if (this.media instanceof HTMLVideoElement) {
          try {
            this.media.currentTime = 0;
          } catch (error) {
            /* 読み込みが済んでいなければ何もしない */
          }
          return;
        }
        this.postExternalCommand('seek');
        this.postExternalCommand('pause');
      }

      play() {
        if (this.media instanceof HTMLVideoElement) {
          this.media.play().catch(() => {});
          return;
        }

        if (!this.media.src) {
          this.loadExternalVideo(true);
          return;
        }

        this.postExternalCommand('play');
      }

      pause() {
        if (this.media instanceof HTMLVideoElement) {
          this.media.pause();
          return;
        }

        if (this.media.src) this.postExternalCommand('pause');
      }

      /* posterOnly … 再生はせずサムネイルだけ出す。あとで再生を命じられるので消音で読み込む */
      loadExternalVideo(shouldAutoplay, posterOnly) {
        const provider = this.dataset.provider;
        const videoId = this.dataset.videoId;
        const loop = this.hasAttribute('data-loop');
        /* 自分から再生しにいく時だけ、再生バーの有無は管理画面の設定に従う。
           動きを減らす設定などで自動再生しない時は、再生する手段が要るので必ず出す */
        const wantControls = shouldAutoplay || posterOnly ? this.showControls : true;
        const controls = wantControls ? '1' : '0';
        const autoplay = shouldAutoplay ? '1' : '0';
        const mute = shouldAutoplay || posterOnly ? '1' : '0';

        if (provider === 'youtube') {
          const loopParameters = loop ? `&loop=1&playlist=${videoId}` : '';
          this.media.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&playsinline=1&controls=${controls}&mute=${mute}&autoplay=${autoplay}${loopParameters}&rel=0&modestbranding=1&origin=${encodeURIComponent(window.location.origin)}`;
        } else {
          this.media.src = `https://player.vimeo.com/video/${videoId}?api=1&playsinline=1&controls=${controls}&muted=${mute}&autoplay=${autoplay}&loop=${loop ? '1' : '0'}`;
        }
      }

      postExternalCommand(command) {
        const target = this.media.contentWindow;
        if (!target) return;

        if (this.dataset.provider === 'youtube') {
          const func = { play: 'playVideo', pause: 'pauseVideo', seek: 'seekTo' }[command];
          target.postMessage(
            JSON.stringify({ event: 'command', func: func, args: command === 'seek' ? [0, true] : '' }),
            '*'
          );
          return;
        }

        if (command === 'seek') {
          target.postMessage(JSON.stringify({ method: 'setCurrentTime', value: 0 }), '*');
          return;
        }
        target.postMessage(JSON.stringify({ method: command }), '*');
      }
    }
  );
})();
